import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OutOfSyncState } from '../../../../providers/nav-sidebar';
import { UserProvider } from '../../../../providers/user';
import { WhiteLabelProvider } from '../../../../providers/white-label';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'nav-sidebar-out-of-sync',
    templateUrl: 'nav-sidebar-out-of-sync.html'
})
export class NavSidebarOutOfSyncWarning {
    @Input() public currentState: OutOfSyncState;
    @Input() public enableStaticClassifier: boolean;
    @Input() public enableAnomalyHiFi: boolean;
    @Input() public isExpanded: boolean;
    @Output() onNavigate: EventEmitter<OutOfSyncState> = new EventEmitter();

    constructor(
        public whiteLabelProvider: WhiteLabelProvider,
        public userProvider: UserProvider,
        private translate: TranslateService
    ) {}

    public getOutOfSyncMessage(): string {
        if (
            (this.currentState === OutOfSyncState.AnomalyRecognizer && !this.enableAnomalyHiFi) ||
            (this.currentState === OutOfSyncState.LearningClassifier && !this.enableStaticClassifier) ||
            this.currentState == OutOfSyncState.Detector
        ) {
            return this.translate.instant('Brain out-of-sync');
        }

        if (this.currentState === OutOfSyncState.AnomalyRecognizer && this.enableAnomalyHiFi) {
            return this.translate.instant('Anomaly Recognizer');
        }

        if (this.currentState === OutOfSyncState.AnomalyHiFi) {
            return this.translate.instant('Anomaly Hi-Fi');
        }

        if (this.currentState === OutOfSyncState.LearningClassifier && this.enableStaticClassifier) {
            return this.translate.instant('Learning Classifier');
        }

        if (this.currentState === OutOfSyncState.StaticClassifier) {
            return this.translate.instant('Static Classifier');
        }

        if (this.currentState === OutOfSyncState.WhiteLabelLearningClassifier) {
            return this.translate.instant('Working Brain');
        }

        if (this.currentState === OutOfSyncState.WhiteLabelStaticClassifier) {
            // See BB-5225, The FLIR labeling here requires a one-off change to shorten the name
            // so it will fit in the navbar better
            if (this.userProvider.isFireflyUser()) {
                return `${this.whiteLabelProvider.getSensorName()} Brain`;
            } else {
                return `${this.whiteLabelProvider.getBrainName()} Brain`;
            }
        }

        return '';
    }

    public getTooltip(): string {
        let brainTooltipName;
        let tooltipSuffix;

        if (
            this.currentState === OutOfSyncState.WhiteLabelStaticClassifier &&
            this.userProvider.shouldSeeWhiteLabelCopy()
        ) {
            brainTooltipName = `${this.whiteLabelProvider.getBrainName()} Brain`;
        } else {
            brainTooltipName = this.currentState;
        }

        if (
            this.currentState === OutOfSyncState.StaticClassifier ||
            this.currentState === OutOfSyncState.WhiteLabelStaticClassifier ||
            this.currentState === OutOfSyncState.AnomalyHiFi
        ) {
            tooltipSuffix = 'for rebuild options';
        } else {
            tooltipSuffix = 'to retrain';
        }

        return `${brainTooltipName} is out-of-sync. Click ${tooltipSuffix}.`;
    }
}



// WEBPACK FOOTER //
// ./src/components/core/nav-sidebar/out-of-sync-warning/nav-sidebar-out-of-sync.ts